import { formatServerDateTimeToLocal } from "utils/dateTimeFormat.js";

const clientHistoryTableColumns = [
  {
    id: "modifiedDate",
    label: "Time",
    accessor: (d) => formatServerDateTimeToLocal(d.modifiedDate, "dateTime"),
  },
  {
    id: "auditActionDesc",
    label: "Action",
  },
  {
    id: "modifiedByName",
    label: "User",
  },
];

export default clientHistoryTableColumns;
